import { atom } from "recoil";

const stateFilterGene = atom({
    key: 'filter.gene',
    default: null as string | null
});

export default stateFilterGene;
